module.exports = __webpack_public_path__ + "img/bg_logo-big.b181dc51.svg";